import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { AvStatusPillComponent } from '../../../../../Shared/Components/av-status-pill/av-status-pill.component';
import { scaleRatio } from '../../../../../Shared/Services/count-up-value.util';
import { TranslationService } from '../../../../../Shared/Services/translation.service';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { MonitoringApproval } from '../../../Interfaces/monitoring-report.interface';
import { formatMonthName } from '../../../Shared/monitoring-month-name.util';
import { MonitoringDeltaComponent } from '../monitoring-delta/monitoring-delta.component';

@Component({
  selector: 'app-monitoring-approval-card',
  standalone: true,
  imports: [COMMON_IMPORTS, AvStatusPillComponent, MonitoringDeltaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-approval-card.component.html',
  host: { class: 'av-metric-card av-metric-card--compact' },
})
export class MonitoringApprovalCardComponent {
  readonly approval = input.required<MonitoringApproval>();
  readonly progress = input<number>(1);
  readonly previousFrom = input<string | null>(null);

  protected readonly language = inject(TranslationService).currentLanguage;

  protected readonly monthName = computed(() => formatMonthName(this.language()));

  protected readonly rate = computed(
    () => scaleRatio(this.approval().rate_percent ?? 0, this.progress()) / 100,
  );

  protected readonly delta = computed(() => this.approval().delta_points);
}
